(function () {
  if (typeof document === 'undefined') return;

  document.addEventListener('theme:cart:popdown', function (e) {
    try {
      var detail = e && e.detail ? e.detail : {};
      var variant = detail.variant || {};
      var id = variant.id || variant.variant_id;
      var qty = Number(variant.quantity);
      var quantity = Number.isFinite(qty) && qty > 0 ? qty : 1;

      if (
        id &&
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('cart_add', {
          items: [{ id: id, quantity: quantity }],
        });
      }
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('analytics bridge error', err);
      }
    }
  });
})();